export default __webpack_public_path__ + "static/media/arrow-right-white.8fa5291d.png";